import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ro } from 'date-fns/locale';
@Component({
  selector: 'app-update-roles',
  templateUrl: './update-roles.component.html',
  styleUrls: ['./update-roles.component.scss'],
})
export class UpdateRolesComponent implements OnInit {
  rolesForm: any = FormGroup;
  isSaved: boolean = false;
  submitted: boolean = false;
  isDisplayed: boolean = false;
  generalMessage: string = '';
  breadcrumbs: any;
  paramId: string | null = '';

  constructor(
    private api: ApiService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.paramId = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de roles',
        path: '/roles/list',
        link: true,
      },
      {
        name: 'Editar roles',
        link: false,
      },
    ];

    this.loadRoles();
    this.validations();
  }

  loadRoles() {
    this.api.getById('roles', Number(this.paramId)).subscribe({
      next: (roles) => {
        this.rolesForm.setValue({
          role: roles.role.role,
          role_key: roles.role.key,
        });
      },
      error: (err) => {},
    });
  }

  get f() {
    return this.rolesForm.controls;
  }

  validations() {
    this.rolesForm = this.fb.group({
      role: ['', [Validators.required, Validators.minLength(2)]],
      role_key: ['', [Validators.required, Validators.minLength(2)]],
    });
  }

  updateRole() {
    this.submitted = true;

    if (this.rolesForm.invalid) {
      return;
    }

    const obj = {
      role: this.rolesForm.value.role,
      role_key: this.rolesForm.value.role_key,
    };

    this.api.update('roles', Number(this.paramId), obj).subscribe({
      next: (roles) => {
        this.submitted = false;
        this.isSaved = true;
        this.generalMessage = roles.message;
      },
      error: (err) => {},
    });

    setTimeout(() => {
      this.submitted = false;
      this.isSaved = false;
      this.isDisplayed = false;
      this.generalMessage = '';
    }, 4000);
  }
}
